import MenuClosed from "components/Menu/MenuClosed";
import MenuOpen from "components/Menu/MenuOpen";
import SidebarContext, { SidebarContextProps } from "contexts/SidebarContext";
import React, { useCallback, useContext } from "react";

export default function SideBar() {
	// Sidebar context
	const { isSidebarOpen, setIsSidebarOpen } = useContext(
		SidebarContext
	) as SidebarContextProps;

	/**
	 * Stop propagation so that clicking on menu items won't trigger a open/close
	 */
	const handleOpen = useCallback(
		e => {
			e.stopPropagation();
			setIsSidebarOpen(!isSidebarOpen);
		},
		[isSidebarOpen, setIsSidebarOpen]
	);

	return (
		<nav
			className={`sidebar menu ${isSidebarOpen ? "open" : "closed"}`}
			aria-label="sidebar menu"
			onClick={handleOpen}>
			{isSidebarOpen ? <MenuOpen /> : <MenuClosed />}
		</nav>
	);
}
